<script lang="ts">
    import { kirbyFetch } from "../../../../api/kirby/api"
    import { spaLink } from "../../../../functionTools/routing"
    import { lang, topics } from "../../../../store"
    import { fallbackLocale } from "../../../../i18n"
    let hoveredEntry: any = $state(-1)

    let {
        topic,
        article_types,
        specific_articles,
    }: {
        topic: string
        article_types: string[]
        specific_articles: string[]
    } = $props()
    let articles: KirbyPage<"articleEntry">[] = $state([])
    async function loadArticles() {
        const articleTemplates = article_types.map((type) => `${type}article`)
        let query = `site.index.filterBy('intendedTemplate', 'in', ['${articleTemplates.join("','")}'])`
        query += `.sortBy('publication_date', 'desc')`
        const articleQuery = {
            id: true,
            title: true,
            tag: true,
            subtitle: true,
            use_video_preview: true,
            video_url: true,
            publication_date: true,
            url: true,
            disable_primary: true,
            type: true,
            topics_reference: true,
            no_en_version: true,
            secondary_links: {
                query: "page.secondary_links.toStructure()",
                select: {
                    text: true,
                    link: true,
                    target: true,
                },
            },
        }

        if (specific_articles.length > 0) {
            query = `site.index.filterBy('Uuid', 'in', ["${specific_articles.join('","')}"])`
        }
        const fetched =
            (
                await kirbyFetch<{ data: KirbyPage<"articleEntry">[] }>({
                    query,
                    limit: 100,
                    select: articleQuery,
                })
            ).data || []

        articles = fetched
            .filter((el) => {
                const topicIds = Object.values($topics)
                    .filter((t) => t.uuid == topic)
                    .map((t) => `- '${t.uuid}'`)
                return topicIds.some((topicId) => el.topics_reference.includes(topicId))
            })
            .filter((el) => $lang === fallbackLocale || !el?.no_en_version)
            .map((el) => {
                el.url = `/${$lang}/` + el.url.split(`/${$lang}/`).pop()
                return el
            })
        if (articles.length > 3) articles = articles.slice(0, 3)
    }

    loadArticles()
</script>

<ul class="position-entries">
    {#each articles as article, idx}
        <li
            class="position-entry"
            class:hoveredEntry={hoveredEntry == idx}
            onmouseenter={() => (hoveredEntry = idx)}
            onmouseleave={() => (hoveredEntry = -1)}
        >
            {#if article.disable_primary}
                <a href={article.secondary_links[0].link} target={article.secondary_links[0].target || "_self"}>
                    <small>{article.tag || "Artikel"}</small>
                    <h5>{article.title}</h5>
                </a>
            {:else}
                <a use:spaLink href={article.url}>
                    <small>{article.tag || "Artikel"}</small>
                    <h5>{article.title}</h5>
                </a>
            {/if}
        </li>
    {/each}
</ul>

<style lang="less">
    .position-entries {
        display: flex;
        flex-direction: column;
        gap: 0.3rem;
        padding: 0px 0.6rem;
        .position-entry {
            transition: all 0.3s ease-in-out;
            a {
                display: flex;
                flex-direction: column;
                small {
                    color: rgba(36, 34, 32, 0.4);
                    font-size: 0.5rem;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 140%;
                    text-transform: uppercase;
                }
                h5 {
                    font-size: 0.7rem;
                    line-height: 140%;
                    color: var(--dark-100);
                    transform: scale(1); /* Startwert */
                    transform-origin: left; /* Wachstum startet von links */
                    transition:
                        transform 0.3s ease,
                        color 0.3s ease; /* Smooth Animation */
                }
            }
        }
        .hoveredEntry {
            padding: 0px 0.6rem;
            a {
                h5 {
                    color: var(--brand-100);
                }
            }
        }
    }
</style>
